<template>
	<div class="mainWrapper returns">
		<h1>Product Returns Details</h1>

		<div class="return-details" v-if="details">
			<div class="first-row">
				<div class="details"><span>RETURN NUMBER</span> <br />{{ details.return_product.code }}</div>
				<div class="details">
					<span>SHOP</span> <br />
					{{ details.return_product.shop.name }}
				</div>
				<div class="details">
					<span>BRAND</span> <br />
					{{ details.return_product.brand.name }}
				</div>
				<div class="details">
					<span>REQUESTED BY</span> <br />
					{{ details.return_product.author.name }}
				</div>
				<div class="details">
					<span>REASON</span> <br />
					{{ details.return_product.type[0] }}
				</div>
				<div class="details">
					<span>STATUS</span> <br />
					{{ displayStatus() }}
				</div>
				<div class="details">
					<span>CREATED</span> <br />
					{{ convertTime(details.return_product.createdAt) }}
				</div>
			</div>

			<div class="list">
				<div class="returnDetailList header">
					<div>BD CODE</div>
					<div>BARCODE</div>
					<div>PRODUCT NAME</div>
					<div>RETURNED QUANTITY</div>
				</div>

				<div v-for="(item, index) of details.return_product_items" v-bind:key="index" class="returnDetailList">
					<div>{{ item.product.bd_code }}</div>
					<div>{{ item.product.barcode }}</div>
					<div>{{ item.product.name }}</div>
					<div>{{ item.qty }}</div>
				</div>
			</div>
		</div>

		<div class="return-detail-buttons-wrapper" v-if="details">
			<div class="align-left">
				<b-button type="is-dark" icon-left="arrow-left" @click="back()">BACK</b-button>
			</div>
			<div class="align-right">
				<button @click="confirm" class="big-button" v-if="details.return_product.status">
					CONFIRM RETURN
				</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Returns',
	data: function() {
		return {
			id: this.$route.params.id, //id from get url
			details: null
		}
	},
	mounted: async function() {
		await this.getDetails()
	},
	methods: {
		getDetails: async function() {
			// Get return detail
			var data = {
				id: this.id,
				populate_return_product: ['author', 'shop', 'brand'],
				populate_return_product_item: ['product']
			}

			const apiGetReturnDetail = await this.$api.getReturnDetail({ data })

			this.details = apiGetReturnDetail.data
		},

		displayStatus: function() {
			if (this.details.return_product.status == true) {
				return 'OPEN'
			} else {
				return 'CLOSE'
			}
		},

		confirm: function() {
			this.$swal
				.fire({
					title: 'Are you sure?',
					text: 'Are you sure you want to confirm this return?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, Confirm!'
				})
				.then(result => {
					if (result.value) {
						this.confirmReturnClose()
					}
				})
		},

		confirmReturnClose: async function() {
			let data = {
				id: this.id
			}

			const apiCloseReturn = await this.$api.closeReturn({ data })

			if (apiCloseReturn !== undefined) {
				// Refresh content
				this.getDetails()

				this.$swal.fire({
					position: 'top-end',
					icon: 'success',
					title: 'Return confirmed!',
					showConfirmButton: false,
					timer: 1500
				})
			}
		},

		back: function() {
			this.$router.go(-1)
		},

		// Convert time
		convertTime: function(time) {
			return this.$moment(time).format('DD/MM/YY hh:mm a')
		}
	}
}
</script>

<style scoped>
@import '../styles/Returns.css';
</style>
